import { TokenWithValue } from '@/domain/common/types'
import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { Button } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'
export interface SuccessPanelProps {
  fromAsset: TokenWithValue
  toAsset: TokenWithValue
  resetForm: () => void
  fromLabel?: string
  toLabel?: string
}

export function SuccessPanel({
  fromAsset,
  toAsset,
  resetForm,
  fromLabel = 'Minted with',
  toLabel = 'Received',
}: SuccessPanelProps) {
  return (
    <div className="flex w-full flex-col items-center justify-center">
      <SuccessViewCheckmark isModal />

      <Panel className="mt-8 min-w-full p-4 sm:p-8">
        <Panel.Header className="flex flex-col items-start gap-8">
          <Panel.Title className="text-xl">Summary</Panel.Title>
        </Panel.Header>

        <Panel.Content>
          <div className={cn('mt-4 flex flex-col gap-9')}>
            {fromAsset && (
              <div className="flex grow flex-col" data-testid={testIds.easyBorrow.success.deposited}>
                <Typography variant="prompt" className="mb-2 font-semibold text-primary">
                  {fromLabel}
                </Typography>
                <Item key={fromAsset.token.symbol} {...fromAsset} />
              </div>
            )}

            <div className="flex grow flex-col" data-testid={testIds.easyBorrow.success.borrowed}>
              <Typography variant="prompt" className="mb-2 font-semibold text-primary">
                {toLabel}
              </Typography>
              <Item key={toAsset.token.symbol} {...toAsset} />
            </div>
          </div>

          <div className="mt-8 w-full">
            <Button onClick={resetForm} rounded="full" className="w-full bg-accent text-primary">
              Close
            </Button>
          </div>
        </Panel.Content>
      </Panel>
    </div>
  )
}

function Item({ token, value }: TokenWithValue) {
  return (
    <div className="flex items-center border-t">
      <TokenIcon token={token} className="h-6 w-6" />

      <Typography className="ml-2 font-primary">{token.symbol}</Typography>

      <div className="flex grow flex-col py-3 pr-4">
        <Typography className="text-right font-primary">{token.format(value, { style: 'auto' })}</Typography>
        <Typography variant="prompt" className="text-right">
          {token.formatUSD(value)}
        </Typography>
      </div>
    </div>
  )
}
